export default {
    bindings: {
        emailContent: '<',
    },
    controller: 'emailViewController',
    template: require('../views/email.content.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/email.view.component.js